"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Chip');

function Chip(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      classNameProp = _ref.className,
      overridesProp = _ref.overrides,
      onClose = _ref.onClose,
      url = _ref.url,
      isShrinked = _ref.isShrinked,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "overrides", "onClose", "url", "isShrinked"]);
  var theme = (0, _styles.useTheme)();
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);
  var rootClassName = (0, _classnames.default)(classes.root, classNameProp);
  var override = (0, _overrides.getOverrides)(overridesProp, Chip.overrides);
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName
  });
  var matches = (0, _react.useMemo)(function () {
    return children && children.match(/\b(\w)/g);
  }, [children]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.wrapper
  }, override.wrapper), url && /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
    className: isShrinked ? classes.shrinkedPicture : classes.picture,
    src: url,
    alt: ""
  }, override.img)), isShrinked && !url && /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    className: classes.shrinked
  }, override.shrinked), matches), !isShrinked && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    className: classes.Text
  }, override.Text), children), onClose && /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    onClick: onClose,
    className: classes.close,
    name: "close",
    size: "small",
    color: theme.colors.text.greySoft
  }, override.Icon)))));
}

Chip.overrides = ['root', 'wrapper', 'img', 'shrinked', 'Text', 'Icon', 'onClose'];
Chip.defaultProps = {
  className: '',
  overrides: {},
  isShrinked: false,
  url: ''
};
process.env.NODE_ENV !== "production" ? Chip.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onClose: _propTypes.default.func,
  isShrinked: _propTypes.default.bool,
  url: _propTypes.default.string
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Chip);

exports.default = _default;